import React from "react";
import { Button, Space, Tooltip, Upload, Typography } from "antd";
import { FolderOpenOutlined, PictureOutlined } from "@ant-design/icons";

const ChatImagePickerDesktop = ({ viewModel }) => {
    return (
        <Space size={8}>
            <Upload
                showUploadList={false}
                multiple
                accept={viewModel.acceptValue}
                beforeUpload={viewModel.handleBeforeUpload}
                disabled={viewModel.loading}
            >
                <Button size={viewModel.buttonSize} style={viewModel.buttonStyle} icon={<PictureOutlined />} />
            </Upload>

            <Tooltip title="Chọn từ thư viện">
                <Button
                    size={viewModel.buttonSize}
                    style={viewModel.buttonStyle}
                    icon={<FolderOpenOutlined />}
                    onClick={viewModel.openLibrary}
                    disabled={viewModel.loading}
                />
            </Tooltip>

            {viewModel.imageCount > 0 ? (
                <Typography.Text type="secondary" style={viewModel.counterTextStyle}>
                    {viewModel.imageCount} ảnh
                </Typography.Text>
            ) : null}
        </Space>
    );
};

export default ChatImagePickerDesktop;